var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartNoAxesColumnIncreasing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7596 0.75828H2.77395C1.66072 0.75828 0.75828 1.65922 0.75828 2.77064V20.8049C0.75828 21.9163 1.66072 22.8173 2.77395 22.8173H15.7596C16.8728 22.8173 17.7753 21.9163 17.7753 20.8049V2.77064C17.7753 1.65922 16.8728 0.75828 15.7596 0.75828Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7765 3.59443H19.4414C20.4287 3.59443 21.2418 4.42909 21.2418 5.43841V23.1792C21.2418 24.1886 20.4287 25.0232 19.4414 25.0232H6.02529C5.03796 25.0232 4.22485 24.1886 4.22485 23.1792",
    stroke: "black",
    strokeWidth: 1.51656,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5951 4.22485H11.2412C11.021 4.22485 10.8425 4.40414 10.8425 4.62532V10.4421C10.8425 10.6633 11.021 10.8426 11.2412 10.8426H13.5951C13.8153 10.8426 13.9938 10.6633 13.9938 10.4421V4.62532C13.9938 4.40414 13.8153 4.22485 13.5951 4.22485Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47344 5.80015H7.79947C7.56556 5.80015 7.37595 5.98177 7.37595 6.20582V10.4365C7.37595 10.6606 7.56556 10.8422 7.79947 10.8422H9.47344C9.70735 10.8422 9.89699 10.6606 9.89699 10.4365V6.20582C9.89699 5.98177 9.70735 5.80015 9.47344 5.80015Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98959 6.74553H4.66604C4.42238 6.74553 4.22485 6.9214 4.22485 7.13835V10.4493C4.22485 10.6663 4.42238 10.8422 4.66604 10.8422H5.98959C6.23325 10.8422 6.43075 10.6663 6.43075 10.4493V7.13835C6.43075 6.9214 6.23325 6.74553 5.98959 6.74553Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.624 13.7997V13.5573C14.624 13.2762 14.4443 13.0482 14.2226 13.0482H4.6262C4.40449 13.0482 4.22477 13.2762 4.22477 13.5573V13.7997C4.22477 14.0809 4.40449 14.3088 4.6262 14.3088H14.2226C14.4443 14.3088 14.624 14.0809 14.624 13.7997Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0482 17.0784V16.8966C13.0482 16.6857 12.8643 16.5148 12.6373 16.5148H4.63546C4.40855 16.5148 4.22462 16.6857 4.22462 16.8966V17.0784C4.22462 17.2893 4.40855 17.4602 4.63546 17.4602H12.6373C12.8643 17.4602 13.0482 17.2893 13.0482 17.0784Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartNoAxesColumnIncreasing);
export default __webpack_public_path__ + "static/media/chart-no-axes-column-increasing.5889b15b04e03240ed7618427877abe4.svg";
export { ForwardRef as ReactComponent };